/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsFeaturedCollection = {
  init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }

    if(this.collection_style == 'slider') {
      this.createSlider();
    }


  },
  createSlider: function() {

    let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');

    const slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true
    }

    $(featuredCollectionSlider).flickity({
      lazyLoad: 2,
//       freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: true,
      pageDots: false,
      contain: true,
      prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(featuredCollectionSlider).on( 'settle.flickity', function() {
            $(featuredCollectionSlider).flickity('resize')
          });
        }
      }
    });
	$('.slider-gallery .flickity-button.flickity-prev-next-button.previous').html('<svg xmlns="http://www.w3.org/2000/svg" width="13.239" height="30.038" viewBox="0 0 13.239 30.038"><path id="Path_74" data-name="Path 74" d="M1832.578,4807.875l8.44,13.135-8.44,11.34" transform="translate(1843.018 4835.149) rotate(180)" fill="none" stroke="#1aab9a" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/></svg>');
	$('.slider-gallery .flickity-button.flickity-prev-next-button.next').html('<svg xmlns="http://www.w3.org/2000/svg" width="13.239" height="30.038" viewBox="0 0 13.239 30.038"><path id="Path_1027" data-name="Path 1027" d="M1832.578,4807.875l8.44,13.135-8.44,11.34" transform="translate(-1829.78 -4805.111)" fill="none" stroke="#1aab9a" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/></svg>');
  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;

	